module.exports = __webpack_public_path__ + "img/create-account.396bdc7e.png";